// src/utils/userFilters.js

/**
 * Filtre les utilisateurs selon une recherche textuelle et un rôle
 * @param {Array} users - Liste des utilisateurs
 * @param {string} searchQuery - Texte recherché (nom ou email)
 * @param {string} roleFilter - Filtre de rôle (all, admin, superviseur)
 * @returns {Array} Utilisateurs filtrés
 */
export const filterUsersBySearchAndRole = (users, searchQuery, roleFilter) => {
    return users.filter((user) => {
      const matchesSearch =
        user.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.toLowerCase());
  
        const matchesRole =
        roleFilter === "all" || user.role === Number(roleFilter);
  
  
      return matchesSearch && matchesRole;
    });
  };
  